module.exports = __webpack_public_path__ + "static/media/salary-income.2d7c9f0d.svg";